import IconDown from '../icons/down';
import IconArrowLeft from '../icons/arrow-left';
import { GroupsListTypes } from './types';

import styles from './accounts-selector.module.css';
import Checkbox from '../checkbox/checkbox';

export default function GroupsList({
  setSelectedGroupId,
  selectedCategory,
  onBack,
  primaryAccountsSelector,
  setSelectedPrimaryAccounts,
  selectedPrimaryAccountsList,
}: GroupsListTypes) {
  return (
    <>
      <li className={styles.groupsTitle}>
        <button
          type="button"
          className={styles.backButton}
          onClick={onBack}
          tabIndex={-1}
        >
          <IconArrowLeft />
          <div
            className={styles.categoryTitle}
          >{`${selectedCategory?.number} ${selectedCategory?.name}`}</div>
        </button>
      </li>
      {selectedCategory?.accountGroups?.map((item) => {
        const currentSelectedPrimaryAccounts: string[] = [];
        const currentGroupPrimaryAccounts: string[] = [];

        if (primaryAccountsSelector) {
          item.primaryAccounts?.forEach((primary) => {
            currentGroupPrimaryAccounts.push(primary.id);
          });

          selectedPrimaryAccountsList?.forEach((selectedPrimary) => {
            if (
              currentGroupPrimaryAccounts.find(
                (currentPrimary) => currentPrimary === selectedPrimary,
              )
            ) {
              currentSelectedPrimaryAccounts.push(selectedPrimary);
            }
          });
        }

        return (
          <li
            key={item.id}
            className={
              primaryAccountsSelector
                ? styles.primaryAccountsSelectorListItem
                : ''
            }
          >
            <div
              className={
                primaryAccountsSelector ? styles.categoryButtonWrapper : ''
              }
            >
              {primaryAccountsSelector && setSelectedPrimaryAccounts && (
                <div className={styles.selectAllCheckboxWrapper}>
                  <Checkbox
                    name={`category-${item.id}`}
                    type="checkbox"
                    title=""
                    checked={Boolean(
                      currentSelectedPrimaryAccounts.length ===
                      currentGroupPrimaryAccounts.length,
                    )}
                    partialChecked={Boolean(
                      currentSelectedPrimaryAccounts.length > 0 &&
                      currentSelectedPrimaryAccounts.length <
                        currentGroupPrimaryAccounts.length,
                    )}
                    onChange={(e) => {
                      let nextSelectedPrimaryAccounts = ([] as string[]).concat(
                        selectedPrimaryAccountsList as string[],
                      );

                      if (e.target.checked) {
                        item.primaryAccounts?.forEach((primary) => {
                          if (
                            !nextSelectedPrimaryAccounts.find(
                              (selected) => selected === primary.id,
                            )
                          ) {
                            nextSelectedPrimaryAccounts.push(primary.id);
                          }
                        });
                      } else {
                        nextSelectedPrimaryAccounts =
                          nextSelectedPrimaryAccounts.filter(
                            (selectedPrimary) =>
                              currentGroupPrimaryAccounts.every(
                                (currentPrimary) =>
                                  currentPrimary !== selectedPrimary,
                              ),
                          );
                      }

                      setSelectedPrimaryAccounts(nextSelectedPrimaryAccounts);
                    }}
                  />
                </div>
              )}
              <button
                type="button"
                className={`${styles.categoryButton} ${primaryAccountsSelector ? styles.primaryAccountsSelectorButton : ''}`}
                onClick={() => setSelectedGroupId(item.id)}
                tabIndex={-1}
              >
                <div className={styles.categoryButtonLeft}>
                  {item.description}
                </div>
                <div className={styles.categoryButtonRight}>
                  <div
                    className={styles.categoryButtonNumber}
                  >{`${selectedCategory.number}.${item.number}`}</div>
                  <div className={styles.categoryButtonArrow}>
                    <IconDown
                      className={styles.arrowRight}
                      width={12}
                      height={9}
                    />
                  </div>
                </div>
              </button>
            </div>
          </li>
        );
      })}
    </>
  );
}
